import { MODAL_ACTIONS } from './constants';

export const hideAllModal = () => ({
  type: MODAL_ACTIONS.HIDE_ALL_MODAL,
});

export const toggleModal = (payload) => ({
  type: MODAL_ACTIONS.TOGGLE_MODAL,
  payload,
});
